<style scoped>

  .tab-segment {
    min-height: 350px;
  }

</style>

<template>

  <div>

    <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>
  
    <div v-else class="ui grid animated fadeIn">

      <p v-if="certs.length == 0" class="grey text m-t-20"><i class="info circle icon"></i> Nenhum laudo criado para essa ficha</p>

      <div v-else class="ui sixteen wide column">
        <table class="ui celled selectable tablet stackable table">
          <thead v-if="$isDesktop">
            <tr>
              <th>Número</th>            
              <th>Status</th>
              <th>Data</th>              
              <th>Serviço</th>
              <th>Colaborador</th>
            </tr>  
          </thead>
          <tbody>
            <tr v-for="(cert, index) in certs" @click="$router.push(`/procs/certs/${cert.id}/show?historyBack=true`)">
              <td>
                <strong class="mobile-only">Número: </strong>
                {{ cert.id }}
              </td>
              <td>
                <strong class="mobile-only">Status: </strong>
                <cert-status :status="cert.status" />
              </td>
              <td>
                <strong class="mobile-only">Data: </strong> {{ $formatDate(cert.date) }}
              </td>
              <td>
                <strong class="mobile-only">Serviço: </strong>
                <span v-html="renderService(cert)"></span>
              </td>
              <td>
                <strong class="mobile-only">Colaborador: </strong> {{ cert.userName }}
              </td>            
            </tr>
          </tbody>
        </table>
      </div>

    </div> 

  </div>   

</template>

<script>

  import CertStatus from "@/components/cert-status"
  import AnimalRegistrationService from "@/services/animal-registration-service"
  import SrvService from "@/services/srv-service"

  export default {
    
    name: "AnimalRegistrationCerts",

    data() {
      return {
        loading: true,
        certs: [],
        service: new AnimalRegistrationService(),
      }
    },
    
    props: ["registration"],  

    components: {
      CertStatus,
    },
    
    created() {
      this.loadCerts()
    },

    methods: {

      async loadCerts() {

        this.loading = true

        try {

          this.certs = await this.service.findCerts(this.registration.id)
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },

      renderService(cert) {

        const icon = `<i class="${SrvService.TYPE_ICONS[cert.serviceTypeIcon].icon} m-r-10"></i>`
        const label = `<div class="ui small label m-l-10">${icon} ${cert.serviceTypeDescription}</div>`

        return cert.serviceDescription + label
      },
    },
  }

</script>